import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { IRtpTransactionalSettings } from '../../interfaces/configuration/rtp-transactional-settings.interface';

export abstract class AbstractRtpConfigurationService {
  abstract getRtpTransactionalSettings(
    routingNumber: string
  ): Promise<IRtpTransactionalSettings | undefined>;

  abstract updateRtpTransactionalSettings(
    settings: IRtpTransactionalSettings
  ): Promise<IWebMessage | undefined>;
}
